import { ref } from "vue";
import { useAuthenticatedFetch } from "../auth/useAuthenticatedFetch";
import Swal from "sweetalert2";
import i18n from "@/i18n/index";
import {
  Member,
  EmailMembersRequest,
  CustomWhatsappRequest,
  MemberRequest,
  MembeProspecterRequest,
  renewMemberSubscriptionRequest,
  MemberEditRequest,
  MemberSearchParams,
  MemberPointeuseErrorSearchParams,
  MemberSummary,
  SyncSubscriptionMembersSearchParams,
  AttachedPointeusesToMemberRequest,
  MemberRenewalSearchParams,
} from "@/interfaces/member";

import {
  syncTest,
  members,
  fiche_member,
  members_pointeuses_errors,
  member_summary,
  clubUUID,
  paginationLinks,
} from "@/shared/state";

import router from "@/router/index";
const { authenticatedFetch } = useAuthenticatedFetch();
const API_URL = process.env.VUE_APP_ROOT_API;
export function useMember() {
  const isRequestSync = ref<boolean | false>(false);
  const isRequestMember = ref<boolean | false>(false);
  const errorMember = ref<boolean | false>(false);
  const errorSync = ref<boolean | false>(false);
  const Toast = Swal.mixin({
    toast: true,
    position: "top-right",
    showConfirmButton: false,
    timer: 12000,
    timerProgressBar: true,
  });

  const getMembers = async () => {
    try {
      isRequestMember.value = true;
      errorMember.value = false;
      const response = await authenticatedFetch(
        `${API_URL}members/${clubUUID.value}`,
        {
          method: "GET",
        },
        false,
        "",
        false,
      );
      members.data = response?.data || [];
      isRequestMember.value = false;
    } catch (err) {
      errorMember.value = true;
      isRequestMember.value = false;
    }
  };
  const fetchMembers = async (body: MemberSearchParams) => {
    try {
      isRequestMember.value = true;
      errorMember.value = false;
      members.data = [];
      paginationLinks.value = 0;
      const response = await authenticatedFetch(
        `${API_URL}members/search`,
        {
          method: "POST",
          body: JSON.stringify(body),
        },
        false,
        "",
        false,
      );
      if (response) {
        if (body?.type === "paginate") {
          members.data = response?.data?.data || [];
          paginationLinks.value = response?.data;
          delete paginationLinks.value.data;
        } else if (body?.type === "all") {
          members.data = response?.data || [];
        } else {
          fiche_member.data = response?.data || {};
        }
        isRequestMember.value = false;
      }
    } catch (err) {
      errorMember.value = true;
      isRequestMember.value = false;
    }
  };
   const fetchMembersRenewed = async (body: MemberRenewalSearchParams) => {
     try {
       isRequestMember.value = true;
       errorMember.value = false;
       members.data = [];
       paginationLinks.value = 0;
       const response = await authenticatedFetch(
         `${API_URL}members/renewed/search`,
         {
           method: "POST",
           body: JSON.stringify(body),
         },
         false,
         "",
         false,
       );
       if (response) {
         if (body?.type === "paginate") {
           members.data = response?.data?.data || [];
           paginationLinks.value = response?.data;
           delete paginationLinks.value.data;
         } else if (body?.type === "all") {
           members.data = response?.data || [];
         } else {
           fiche_member.data = response?.data || {};
         }
         isRequestMember.value = false;
       }
     } catch (err) {
       errorMember.value = true;
       isRequestMember.value = false;
     }
   };
  const fetchCountMemberWithPointeuseError = async (
    body: MemberPointeuseErrorSearchParams,
  ) => {
    try {
      isRequestMember.value = true;
      errorMember.value = false;
      members_pointeuses_errors.data = [];
      paginationLinks.value = 0;
      const response = await authenticatedFetch(
        `${API_URL}members-with-pointeuses-errors`,
        {
          method: "POST",
          body: JSON.stringify(body),
        },
        false,
        "",
        false,
      );
      if (response) {
        if (body?.type === "paginate") {
          members_pointeuses_errors.data = response?.data?.data || [];
          paginationLinks.value = response?.data;
          delete paginationLinks.value.data;
        } else if (body?.type === "all") {
          members_pointeuses_errors.data = response?.data || [];
        }
        isRequestMember.value = false;
      }
    } catch (err) {
      errorMember.value = true;
      isRequestMember.value = false;
    }
  };

  const fetchFicheMember = async (body: MemberSearchParams) => {
    try {
      isRequestMember.value = true;
      errorMember.value = false;
      fiche_member.data = null;
      const response = await authenticatedFetch(
        `${API_URL}member/record/inforamtion`,
        {
          method: "POST",
          body: JSON.stringify(body),
        },
        false,
        "",
        false,
      );
      if (response) {
        fiche_member.data = response || {};
        isRequestMember.value = false;
      } else {
        isRequestMember.value = false;
      }
    } catch (err) {
      errorMember.value = true;
      isRequestMember.value = false;
    }
  };

  const fetchMemberByCIN = async (body: MemberSearchParams) => {
    try {
      isRequestMember.value = true;
      errorMember.value = false;
      const response = await authenticatedFetch(
        `${API_URL}member/record/inforamtion`,
        {
          method: "POST",
          body: JSON.stringify(body),
        },
        false,
        "",
        false,
      );
      if (response) {
        isRequestMember.value = false;
        return response || {};
      } else {
        isRequestMember.value = false;
      }
    } catch (err) {
      isRequestMember.value = false;
      errorMember.value = true;
      return errorMember.value;
    }
  };

  const fetchMemberSummary = async (memberUUID: String) => {
    try {
      isRequestMember.value = true;
      errorMember.value = false;
      member_summary.data = null;
      const body = {
        id: null,
        is_paid: "",
        end_date: [],
        pack_id: null,
        subscription_id: null,
        clubUUID: clubUUID.value,
        memberUUID: memberUUID,
        memberName: "",
        memberCIN: "",
        gender: "",
        isActive: "",
        type: "all",
        page: null,
        limit: null,
        with_transactions: "false",
        with_subscription: "false",
        with_pack: "false",
        with_member: "false",
        with_seller: "false",
      };
      const response = await authenticatedFetch(
        `${API_URL}member/record/summary`,
        {
          method: "POST",
          body: JSON.stringify(body),
        },
        false,
        "",
        false,
      );
      if (response) {
        member_summary.data = response || {};
        isRequestMember.value = false;
      }
    } catch (err) {
      isRequestMember.value = false;
      errorMember.value = true;
    }
  };

  const addMember = async (body: MemberRequest) => {
    try {
      isRequestMember.value = true;
      errorMember.value = false;
      const customToastMessage = i18n.t("message.toast.registration.title");
      const response = await authenticatedFetch(
        `${API_URL}member/subscription/new/${clubUUID.value}`,
        {
          method: "POST",
          body: JSON.stringify(body),
        },
        true,
        customToastMessage,
        true,
      );
      if (response) {
        isRequestMember.value = false;
        return response;
      } else {
        isRequestMember.value = false;
      }
    } catch (err) {
      isRequestMember.value = false;
      errorMember.value = true;
    }
  };
  const addMemberProspecter = async (body: MembeProspecterRequest) => {
    try {
      isRequestMember.value = true;
      errorMember.value = false;
      const customToastMessage = i18n.t("message.toast.registration.title");
      const response = await authenticatedFetch(
        `${API_URL}member/prospecter/${clubUUID.value}`,
        {
          method: "POST",
          body: JSON.stringify(body),
        },
        true,
        customToastMessage,
        true,
      );
      if (response) {
        isRequestMember.value = false;
        return response;
      } else {
        isRequestMember.value = false;
      }
    } catch (err) {
      isRequestMember.value = false;
      errorMember.value = true;
    }
  };
  const renewMemberSubscription = async (
    body: renewMemberSubscriptionRequest,
  ) => {
    try {
      isRequestMember.value = true;
      errorMember.value = false;
      const customToastMessage = i18n.t("message.toast.renew.title");
      const response = await authenticatedFetch(
        `${API_URL}member/subscription/renewal/${body?.memberUUID}/${clubUUID.value}`,
        {
          method: "POST",
          body: JSON.stringify(body),
        },
        true,
        customToastMessage,
        true,
      );
      if (response) {
        isRequestMember.value = false;
        return response;
      }
      isRequestMember.value = false;
    } catch (err) {
      isRequestMember.value = false;
      errorMember.value = true;
    }
  };

  const editMember = async (body: MemberEditRequest, from: string) => {
    try {
      isRequestMember.value = true;
      errorMember.value = false;
      const response = await authenticatedFetch(
        `${API_URL}member/edit/${body?.id}/${clubUUID.value}`,
        {
          method: "PUT",
          body: JSON.stringify(body),
        },
        true,
        "",
        true,
      );
      if (response) {
        isRequestMember.value = false;
        if (from == "fiche") {
          if (fiche_member.data) {
            fiche_member.data.member_info = response?.data ?? {};
          }
        } else {
          const memberEdited: Member = response?.data;
          const index = members?.data?.findIndex(
            (member) => member?.id === memberEdited?.id,
          );
          if (index !== -1) {
            members.data[index] = memberEdited;
          }
        }

        return response || {};
      }
      isRequestMember.value = false;
    } catch (err) {
      isRequestMember.value = false;
      errorMember.value = true;
    }
  };

  const deleteMember = async (id: number) => {
    try {
      isRequestMember.value = true;
      errorMember.value = false;
      const response = await authenticatedFetch(
        `${API_URL}member/delete/${clubUUID.value}/${id}`,
        {
          method: "DELETE",
        },
        true,
        "",
        true,
      );
      const index = members?.data?.findIndex((member) => member?.id === id);
      if (index !== -1) {
        members.data.splice(index, 1);
        isRequestMember.value = false;
      }
    } catch (err) {
      isRequestMember.value = false;
      errorMember.value = true;
    }
  };

  const sendMailToMembers = async (body: EmailMembersRequest) => {
    try {
      isRequestMember.value = true;
      errorMember.value = false;
      const response = await authenticatedFetch(
        `${API_URL}member/send/mail/${clubUUID.value}`,
        {
          method: "POST",
          body: JSON.stringify(body),
        },
        false,
        "",
        false,
      );
      if (!response?.data) {
        Toast.fire({
          title: i18n.t("message.toast.paymentremider.error"),
          icon: "error",
        });
        isRequestMember.value = false;
        return false;
      } else {
        Toast.fire({
          title: i18n.t("message.toast.paymentremider.success"),
          icon: "success",
        });
        isRequestMember.value = false;
        return true;
      }
    } catch (err) {
      isRequestMember.value = false;
      errorMember.value = true;
      return false;
    }
  };

  const sendCustomMessageWhatsapp = async (body: CustomWhatsappRequest) => {
    try {
      isRequestMember.value = true;
      errorMember.value = false;
      const response = await authenticatedFetch(
        `${API_URL}member/send/whatsapp/${clubUUID.value}`,
        {
          method: "POST",
          body: JSON.stringify(body),
        },
        false,
        "",
        false,
      );
      if (response?.data || response?.message) {
        Toast.fire({
          html:
            i18n.t("message.toast.customWhatsapp.success") +
            "<br><br>" +
            response?.data?.message,
          icon: "success",
        });
        isRequestMember.value = false;
        return true;
      } else {
        Toast.fire({
          title: i18n.t("message.toast.customWhatsapp.error"),
          icon: "error",
        });
        isRequestMember.value = false;
        return false;
      }
    } catch (err) {
      isRequestMember.value = false;
      errorMember.value = true;
      return false;
    }
  };

  const fetchMembersExportFile = async (body: MemberSearchParams) => {
    try {
      isRequestMember.value = true;
      errorMember.value = false;
      const response = await authenticatedFetch(
        `${API_URL}members/search`,
        {
          method: "POST",
          body: JSON.stringify(body),
        },
        false,
        "",
        false,
      );

      if (response) {
        isRequestMember.value = false;
        return {
          members: response?.data || {},
        };
      }
    } catch (err) {
      isRequestMember.value = false;
      errorMember.value = true;
    }
  };
   const fetchMembersRenewalExportFile = async (
     body: MemberRenewalSearchParams,
   ) => {
     try {
       isRequestMember.value = true;
       errorMember.value = false;
       const response = await authenticatedFetch(
         `${API_URL}members/renewed/search`,
         {
           method: "POST",
           body: JSON.stringify(body),
         },
         false,
         "",
         false,
       );

       if (response) {
         isRequestMember.value = false;
         return {
           members: response?.data || {},
         };
       }
     } catch (err) {
       isRequestMember.value = false;
       errorMember.value = true;
     }
   };


  /**
   * Pointeuses
   */
  const AttachDetachPointeusesToMember = async (
    body: AttachedPointeusesToMemberRequest,
  ) => {
    try {
      isRequestMember.value = true;
      errorMember.value = false;
      const response = await authenticatedFetch(
        `${API_URL}member/pointeuses/${clubUUID.value}`,
        {
          method: "POST",
          body: JSON.stringify(body),
        },
        true,
        "",
        true,
      );
      if (response) {
        isRequestMember.value = false;
        return response || {};
      }
      isRequestMember.value = false;
    } catch (err) {
      isRequestMember.value = false;
      errorMember.value = true;
    }
  };

  //  const deleteMemberFromPointeuseHikvision = async (
  //    body: HikvisionDeleteMember
  //  ) => {
  //    try {

  //      const API_BASE_URL = "http://localhost:3000";
  //      const client = axios.create({
  //        baseURL: API_BASE_URL,
  //        timeout: 30000,
  //        headers: {
  //          "Content-Type": "application/json",
  //        },
  //      });

  //      const response = await client.delete("/api/members/delete", {
  //        data: body,
  //      });

  //      console.log(response.data.results);
  //    } catch (err: any) {
  //      console.log(err);
  //    }
  //  };

  return {
    AttachDetachPointeusesToMember,
    getMembers,
    addMember,
    addMemberProspecter,
    editMember,
    deleteMember,
    fetchMembers,
    fetchMembersRenewed,
    fetchFicheMember,
    fetchMemberSummary,
    fetchMemberByCIN,
    renewMemberSubscription,
    sendMailToMembers,
    sendCustomMessageWhatsapp,
    fetchMembersExportFile,
    fetchMembersRenewalExportFile,
    fetchCountMemberWithPointeuseError,
    isRequestMember,
    isRequestSync,
    errorMember,
    errorSync,
  };
}
